import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';
import { useApolloTracker } from '@/hooks/useApolloTracker';

export const GoogleAnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  useGoogleAnalytics();
  useApolloTracker();
  return <>{children}</>;
};
